// src/Components/AppointmentForm.jsx
import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase';
import '../styles/AppointmentForm.css';

const AppointmentForm = () => {
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false); // Modal state

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'appointments'), {
        name,
        mobile,
        message,
        timestamp: serverTimestamp(),
      });
      setShowModal(true); // Show modal on success
      setName('');
      setMobile('');
      setMessage('');
    } catch (error) {
      console.error('Error booking appointment: ', error);
      // Removed alert
    }
  };

  const closeModal = () => {
    setShowModal(false); // Close modal
  };

  return (
    <div className='appointment-form-container'>
      <h1>Book an Appointment</h1>
      <form className="appointment-form" onSubmit={handleSubmit}>
        <label htmlFor="name">Name:</label>
        <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your Name" required />

        <label htmlFor="mobile">Mobile:</label>
        <input type="tel" id="mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="Your Mobile Number" required />

        <label htmlFor="message">Message:</label>
        <textarea id="message" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Your Message" required />

        <button type="submit">Book Appointment</button>
      </form>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <p>Your appointment booked successfully! 
                <br /> 
                We will Contact you soon...
            </p>
            <button onClick={closeModal}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentForm;